export const GET_NOTIFICATION_LIST_REQUEST = 'ADVERTISEMENT/GET_NOTIFICATION_LIST_REQUEST';
export const GET_NOTIFICATION_LIST_SUCCESS = 'ADVERTISEMENT/GET_NOTIFICATION_LIST_SUCCESS';
export const RESET_NOTIFICATION = 'ADVERTISEMENT/RESET_NOTIFICATION';

export const OPEN_ADVERTISEMENT_REQUEST = 'ADVERTISEMENT/OPEN_ADVERTISEMENT_REQUEST';
export const OPEN_ADVERTISEMENT_SUCCESS = 'ADVERTISEMENT/OPEN_ADVERTISEMENT_SUCCESS';
export const CLOSE_ADVERTISEMENT = 'ADVERTISEMENT/CLOSE_ADVERTISEMENT';

export const NOTIFICATION_LOADING_END = 'ADVERTISEMENT/NOTIFICATION_LOADING_END';
